import { InputButton } from '@abbott-components/core';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useSnackbar } from 'notistack';
import { useContext } from 'react';
import ControlState from '../Shared/controlState';
import { remove } from '../Shared/ajax';
import { getErrorMessage } from '../Shared/errorHandling';
import {
  WorkflowEngineActionKind,
  WorkflowEngineContext
} from '../WorkflowEngine/workflowEngineReducer';

export default (props: { control: ControlState; onClose: () => void }) => {
  const { control, onClose } = props;
  const { dispatch } = useContext(WorkflowEngineContext);
  const { enqueueSnackbar } = useSnackbar();

  const { pageId } = control;

  const savePageDeletion = async (pageId: string) => {
    try {
      await remove(`DynamicWorkflowPage/${pageId}`);
      enqueueSnackbar('Page was successfully deleted.', {
        variant: 'success'
      });
    } catch (err) {
      enqueueSnackbar(getErrorMessage(err), { variant: 'error' });
    }
  };

  const deleteHandler = async () => {
    dispatch({
      type: WorkflowEngineActionKind.DELETE_PAGE,
      payload: pageId
    });

    await savePageDeletion(pageId);
  };

  return (
    <Stack>
      <Typography>
        Are you sure you want to delete this page/section and all its associated
        contents?
      </Typography>
      <Stack direction="row" mt={2} gap={1} justifyContent="right">
        <InputButton
          name="cancelDelete"
          type="button"
          variant="text"
          onClick={onClose}
        >
          Cancel
        </InputButton>
        <InputButton name="confirmDelete" type="button" onClick={deleteHandler}>
          Delete
        </InputButton>
      </Stack>
    </Stack>
  );
};
